import { IconChevronRightOutline18 as ChevronRight } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"

// Rows are 30.4px tall, so every box inside one lands on a fractional pixel and
// WebKit re-snaps a rotating stroke mid-transition. The rotation is instant, and
// transform-gpu keeps the resting glyph on one layer.
export const NavDisclosureChevron = ({
	isOpen,
	className,
}: {
	isOpen: boolean
	className?: string
}) => (
	<span
		aria-hidden
		data-testid="nav-disclosure-chevron"
		className={cn(
			"pointer-events-none flex h-6 w-6 flex-none transform-gpu items-center justify-center text-tertiary dark:text-gray-400",
			isOpen ? "rotate-90" : "rotate-0",
			className,
		)}
	>
		<ChevronRight strokeWidth={1.75} className="h-3 w-3 flex-none" />
	</span>
)
